/**
 * The one rule this file exists to enforce: in the right-hand column of the cancel
 * chat, SOLID BROWN MEANS SENT.
 *
 * Sent messages and reply options share that column. A sent message is a solid brown
 * bubble with white text; a reply option is something the customer COULD say. When a
 * "primary" reply option was also given solid brown + white text, it became
 * pixel-identical to a message they had already sent — so a live "Delay for 2 weeks"
 * button, sitting above three outlined alternatives, read as a choice already made.
 * A customer looking at the screenshot could not tell the offer from the history.
 *
 * The fill is therefore reserved. A primary CTA uses the widget's brand-primary
 * pairing instead (pink fill, brown text — as in CartSheet and BuyAgainPanel):
 * emphatic, on-brand, and unmistakably not a sent bubble.
 *
 * VARIANT ORDER: this package prefixes Tailwind with `tw:`, so variants go
 * `tw:hover:` / `tw:disabled:`. Written the other way round (`hover:tw:`) Tailwind
 * emits NO rule — the class still lands in the DOM and matches nothing, which is why
 * these buttons previously had neither hover nor disabled styling despite appearing
 * to. See [[project_widget_tailwind_prefix_first]].
 */

/** The sent-message bubble's identity. Reserved — reply options may not wear it. */
export const SENT_BUBBLE_FILL = "tw:bg-[#523D33]";
export const SENT_BUBBLE_TEXT = "tw:text-white";

/** Brand primary: pink fill, brown text. Emphatic without impersonating a message. */
const PRIMARY = "tw:bg-[#FAC8CA] tw:text-[#523D33] tw:hover:bg-[#FAC8CA]/80";

const SECONDARY =
  "tw:border tw:border-[#523D33]/40 tw:bg-white tw:text-[#523D33] tw:hover:bg-[#FDEDEE]/60";

const BASE =
  "tw:max-w-[85%] tw:px-4 tw:py-2 tw:text-sm tw:font-medium tw:transition-colors tw:cursor-pointer tw:disabled:opacity-50 tw:disabled:cursor-not-allowed";

/** Classes for one tappable reply option / offer CTA. */
export function replyOptionClassName(o: {
  primary?: boolean;
  sublabel?: string;
}): string {
  return [
    BASE,
    o.sublabel ? "tw:rounded-2xl" : "tw:rounded-full",
    o.primary ? PRIMARY : SECONDARY,
  ].join(" ");
}
